import { Button } from '@/components/ui/button'
import { Github, Chrome } from 'lucide-react'
import { supabase } from '@/lib/supabase'
import { getAuthRedirectUrl } from '@/lib/url-utils'

interface OAuthButtonsProps {
  onError?: (error: string) => void
}

export function OAuthButtons({ onError }: OAuthButtonsProps) {
  const handleGoogleLogin = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: getAuthRedirectUrl()
        }
      })
      
      if (error) {
        console.error('Error logging in with Google:', error.message)
        onError?.(error.message)
      }
    } catch (err) {
      const errorMessage = 'Failed to sign in with Google'
      console.error(errorMessage, err)
      onError?.(errorMessage)
    }
  }

  const handleGitHubLogin = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'github',
        options: {
          redirectTo: getAuthRedirectUrl()
        }
      })
      
      if (error) {
        console.error('Error logging in with GitHub:', error.message)
        onError?.(error.message)
      }
    } catch (err) {
      const errorMessage = 'Failed to sign in with GitHub'
      console.error(errorMessage, err)
      onError?.(errorMessage)
    }
  }

  return (
    <div className="space-y-2">
      <Button 
        onClick={handleGoogleLogin}
        variant="outline"
        className="w-full" 
        size="lg"
      >
        <Chrome className="w-5 h-5 mr-2" />
        Continue with Google
      </Button>
      
      <Button 
        onClick={handleGitHubLogin}
        variant="outline"
        className="w-full" 
        size="lg"
      >
        <Github className="w-5 h-5 mr-2" />
        Continue with GitHub
      </Button>
    </div>
  )
}